import React from 'react';
import { ArrowDown, ArrowUpRight } from 'lucide-react';
import HeroMedia from './HeroMedia';
import ReviewBadge from './ReviewBadge';
import { trackEvent } from '../analytics';

const PUB = process.env.PUBLIC_URL || '';

export default function AtelierHero({ children }) {
  return (
    <>
      <section className="atelier-hero" id="top" aria-labelledby="atelier-hero-title" data-testid="hero-section">
        <figure className="atelier-hero-film" data-testid="hero-media">
          <HeroMedia src={`${PUB}/hero/deck-film.mp4`} poster={`${PUB}/hero/hero-desk-1600.jpg`}>
            <picture>
              <source type="image/webp" srcSet={`${PUB}/hero/hero-desk-1600.webp`} />
              <img src={`${PUB}/hero/hero-desk-1600.jpg`} width="1600" height="893" fetchPriority="high" decoding="async"
                alt="Design inspiration: a timber deck and pergola overlooking the coast at sunset" />
            </picture>
          </HeroMedia>
        </figure>
        <div className="atelier-hero-shade" aria-hidden="true" />
        <div className="container atelier-hero-content">
          <p className="atelier-kicker atelier-hero-location"><span /> Hobart, Australia <span className="atelier-location-divider">/</span> Carpentry &amp; renovations</p>
          <h1 id="atelier-hero-title"><span className="atelier-title-line"><span>Pride in the craft.</span></span><span className="atelier-title-line"><em>Respect for your home.</em></span></h1>
          <div className="atelier-hero-bottom">
            <p>Carpentry, renovations and repairs in Hobart. Deal directly with Corey, from the first conversation to the finishing touches.</p>
            <a href="#contact" className="atelier-button atelier-button--light" data-testid="hero-quote-btn"
              onClick={() => trackEvent('quote_cta_click', { location: 'hero' })}>Tell me about your project <ArrowUpRight size={20} aria-hidden="true" /></a>
          </div>
          <div className="atelier-hero-reviews"><ReviewBadge variant="hero" /></div>
          <a href="#services" className="atelier-scroll" data-testid="hero-viewwork-link"><span>Explore FairFix</span><ArrowDown size={17} aria-hidden="true" /></a>
        </div>
      </section>
      {children}
      <div className="atelier-intro" data-testid="cred-strip">
        <div className="container atelier-intro-grid">
          <p className="atelier-kicker">Local hands.<br />{' '}Lasting care.</p>
          <p className="atelier-intro-statement">From the fix you&rsquo;ve been putting off<br className="atelier-desktop-break" /> to the space you&rsquo;ve been imagining.</p>
          <p className="atelier-intro-facts"><span>Certificate III in Carpentry</span><span>20 years on the tools · Fully insured</span><span>Hobart &amp; surrounds, Australia</span></p>
        </div>
      </div>
    </>
  );
}
